import { Stack, Typography } from '@mui/material'
import { Form } from '@ui/forms'
import FormFields from './components/FormFields'
import { DefaultValues } from './types'

interface Props {
  onSubmit: (data: DefaultValues) => void
}

const UploadNewPlan = ({ onSubmit }: Props) => {
  const defaultValues: DefaultValues = {
    title: '',
    comment: '',
    file: null,
  } as unknown as DefaultValues

  return (
    <Form
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      resetIsDirtyAfterSubmit
      id={'upload-plan-form'}
    >
      <Stack spacing={2}>
        <Typography variant="h5">Neue Datei</Typography>

        <FormFields />
      </Stack>
    </Form>
  )
}

export default UploadNewPlan
